<template>
    <div class="saleManagerReport">
        ====================》这是saleManagerReport页
    </div>
</template>
<script>
export default {
    name:'saleManagerReport',
      data() {
        return {
        
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// saleManagerReport.vue?cd6b42e6